import React from "react";
import {
  Menu,
  MenuItem,
  Divider,
  Box,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import {
  ProgramTemplateCategory,
  ProgramTemplateDto,
} from "@growth-machine-llc/stridist-api-client";
import { exerciseTagCategoryMultiSelectStyles } from "../exercise-library/exerciseLibraryStyles";

const getCategoryLabel = (category: ProgramTemplateCategory): string => {
  if (category === ProgramTemplateCategory.NONE) return "None";
  return category
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};

const ProgramTemplateCategoryLabels = Object.values(
  ProgramTemplateCategory,
).reduce(
  (acc, category) => {
    acc[category] = getCategoryLabel(category);
    return acc;
  },
  {} as Record<ProgramTemplateCategory, string>,
);

export interface ProgramCategorySelectProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  anchorEl: HTMLElement | null;
  template: ProgramTemplateDto;
  selectedCategory: ProgramTemplateCategory | null;
  onCategoryChange: (category: ProgramTemplateCategory) => void;
  readonly?: boolean;
}

export function ProgramCategorySelect({
  open,
  setOpen,
  anchorEl,
  template,
  selectedCategory,
  onCategoryChange,
  readonly = false,
}: ProgramCategorySelectProps) {
  const s = exerciseTagCategoryMultiSelectStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const handleCategorySelect = (category: ProgramTemplateCategory) => {
    if (readonly) return;
    onCategoryChange(category);
    setOpen(false);
  };

  const options = Object.values(ProgramTemplateCategory);

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            minWidth: 300,
            maxHeight: 400,
          },
        },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      className={s.menu}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <MenuItem className={s.menuHeader}>
        {readonly ? "Category" : "Select category"}
      </MenuItem>
      <Divider />
      {options.map((option) => {
        const selected = selectedCategory === option;

        return (
          <MenuItem
            key={String(option)}
            disabled={readonly && !selected}
            className={s.menuItem}
            onClick={() => handleCategorySelect(option)}
          >
            <Box display={"flex"} alignItems={"center"}>
              <Box
                sx={{
                  width: 20,
                  display: "inline-flex",
                  justifyContent: "center",
                  mx: 1,
                }}
              >
                {selected && <DoneIcon color="primary" fontSize="small" />}
              </Box>
              {ProgramTemplateCategoryLabels[option]}
            </Box>
          </MenuItem>
        );
      })}
    </Menu>
  );
}

